<template>
	<section>
		<el-drawer placement="right" class="in" :visible="visible" size="40%" :show-close="false"
			:append-to-body="true">
			<div slot="title" style="display:flex;justify-content:space-between;">
				<span>设置规则</span>
				<div>
					<el-button size="small" @click="close">关闭</el-button>
					<el-button size="small" type="primary" @click="submit">保存</el-button>
				</div>
			</div>

			<el-main>
				<div v-if="type=='PHOTO'">
					<el-radio-group @change="curKeyChange" v-model="permission_type"
						style="display:flex;flex-direction:column;">
						<el-radio label="PARENT">
							<span>幼儿个性化内容</span>
							<el-form style="margin:20">
								<el-form-item label>
									<el-checkbox v-model="content_permission"
										:disabled="permission_type!='PARENT'||is_disable?true:false"
										@change="chageParentEdit">家长可编辑内容</el-checkbox>
								</el-form-item>
								<el-form-item label>
									<el-checkbox v-model="model_permission" :disabled="!content_permission||is_disable">
										允许家长从配置模板中选择模板</el-checkbox>
								</el-form-item>
							</el-form>
						</el-radio>
						<el-radio label="TEACHER" style="margin: 20 0">同一个班内容相同，由各班老师设置内容</el-radio>
						<el-radio label="KINDERGARTEN">全园一样内容，由管理员上传</el-radio>
					</el-radio-group>
					<el-form style="margin:20">
						<el-form-item label="所属年级">
							<el-select placeholder="所属年级" filterable v-model="grade" style="width:90%;" clearable>
								<el-option v-for="opt in grade_list" :key="opt.id" :label="opt.name" :value="opt.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="所属学期">
							<select-term style="width:90%" v-model="term" />
						</el-form-item>
						<el-form-item label="图文来源">
							<el-select placeholder="选择标签（多选）" filterable @change="tagsChange" multiple
								:multiple-limit="datasource_ids.findIndex(e=>e==0)!=-1?1:null" v-model="datasource_ids"
								style="width:90%;">
								<el-option v-for="opt in tag_list" :key="opt.id" :label="opt.name" :value="opt.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>
				<div v-else-if="type.includes('PHOTO')">
					<el-form style="margin:20">
						<el-form-item label="所属年级">
							<el-select placeholder="所属年级" filterable v-model="grade" style="width:90%;">
								<el-option v-for="opt in grade_list" :key="opt.id" :label="opt.name" :value="opt.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="图文来源">
							<el-select placeholder="选择系统标签（多选）" @change="tagsChange" multiple
								:multiple-limit="datasource_ids.findIndex(e=>e==0)!=-1?1:null" v-model="datasource_ids"
								style="width:90%;">
								<el-option v-for="opt in tag_list" :key="opt.id" :label="opt.name" :value="opt.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>

				<div v-else-if="type=='QUESSTIONS'||type=='ONE_QUESSTION'||type=='QUESTIONWEEK'">
					<el-checkbox v-model="model_permission">允许家长从配置模板中选择模板</el-checkbox>
					<el-form style="margin:20" label-width="80px">
						<el-form-item label="学年">
							<select-year v-model="schoolYear" @change="getQuestionList" />
						</el-form-item>
						<el-form-item label="所属学期">
							<select-term  v-model="term" @change="getQuestionList"/>
						</el-form-item>
						<el-form-item label="共育主题">
							<el-select placeholder="家园共育主题" filterable v-model="questionnaire_id" style="width:70%"
								:disabled="is_disable">
								<el-option v-for="opt in tag_list" :key="opt.id" :label="opt.name" :value="opt.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>
				<div v-else-if="type=='HEALTHY'">
					<p>健康档案的设置</p>
					<el-form style="margin:20">
						<el-form-item label="体检信息">
							<el-select placeholder="体检信息(可多选)" filterable multiple v-model="topic_id" style="width:90%;"
								:disabled="is_disable">
								<el-option v-for="opt in tag_list" :key="opt.id" :label="opt.name" :value="opt.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</div>
			</el-main>
		</el-drawer>
	</section>
</template>

<script>
	import { } from "@/api/book";
	import { education_growth, evaluation_list } from "@/api/education";
	import { tags } from "@/api/server";
	import SelectYear from '../select-year.vue';
	import SelectTerm from '@/components/select-term'

	export default {
		data() {
			return {
				grade_list: [
					{ id: 1, name: "豆豆班" },
					{ id: 2, name: "小小班" },
					{ id: 3, name: "小班" },
					{ id: 4, name: "中班" },
					{ id: 5, name: "大班" },
				],
				grade: null,
				schoolYear:null,
				term:null,
				visible: false,

				type: "PHOTO", //PHOTO图片设置，QUESTION问卷设置,HEALTHY体检记录

				permission_type: "PARENT", //0个性化，1同一个班内容相同，由各班老师设置内容，2全园一样内容，由管理员上传

				datasource_ids: [],
				tag_list: [],

				content_permission: true, //true家长可编辑
				model_permission: false, //true家长可选择模板
				questionnaire_id: null,
				topic_id: [],
				orginData: {},
				is_disable: false //true 仅查看
			};
		},

		computed: {},

		components: { SelectYear,SelectTerm },

		methods: {

			openVisible(data, is_disable) {
				
				this.orginData = data
				this.visible = true;
				this.is_disable = is_disable; //true不可编辑
				this.tag_list = [];
				this.type = data.content_type
					? data.content_type.schema_str
					: "PHOTO";

				this.permission_type = data.config
					? data.config.permission_type
					: "PARENT";
				this.datasource_ids =
					data.config && data.config.datasource
						? data.config.datasource
						: [];
				this.content_permission = data.config
					? data.config.content_permission
					: true;
				this.model_permission = data.config
					? data.config.model_permission
					: true;
				this.questionnaire_id = data.config
					? data.config.questionnaire_id
					: null;
				this.topic_id = data.config ? data.config.topic_id : [];
				this.grade = data.config ? data.config.grade : null;
				this.term = data.config ? data.config.term : null;
				console.log('==this.term===>',this.term)

				if (this.type.includes("PHOTO")) {
					tags.getAll({ page: 1, size: 999 }).then(res => {
						if (res.data) {
							this.tag_list = [{ id: 0, name: "全部标签" }].concat(
								res.data.map(r => {
									return { id: r.id, name: r.name };
								})
							);
						}
					});
				} else if (this.type == "HEALTHY") {
					education_growth.find().then(res => {
						if (res.data) {
							this.tag_list = res.data.map(r => {
								return { id: r.id, name: r.title };
							});
						}
					});
				} else if (
					this.type == "QUESSTIONS" ||
					this.type == "ONE_QUESSTION" ||
					this.type == "QUESTIONWEEK"
				) {
					this.getQuestionList()
				}
			},
			getQuestionList() {
				this.questionnaire_id = null
				console.log('this.orginData.questionnaire_id', this.orginData)
				evaluation_list.getSimpleList({ 'school_year': this.schoolYear,'term':this.term }).then(res => {
					if (res.data) {
						this.tag_list = res.data.map(r => {
							return { id: r.id, name: r.title };
						});
						console.log('==sd==', this.orginData.config)
						this.questionnaire_id = this.orginData.config.questionnaire_id
					}
				});
			},
			submit() {
				if (
					this.type.includes("PHOTO") &&
					this.datasource_ids.length == 0
				) {
					this.$message({
						message: "请选择图文来源",
						type: "success"
					});
					return;
				}
				let config = {
					datasource:
						this.datasource_ids && this.datasource_ids.length > 0
							? this.datasource_ids.findIndex(e => e == 0) == 0
								? this.tag_list.map(r => r.id).filter(z => z != 0)
								: this.datasource_ids
							: [],
					content_permission: this.content_permission,
					model_permission: this.model_permission,
					questionnaire_id: this.questionnaire_id,
					permission_type: this.permission_type
						? this.permission_type
						: "PARENT",
					topic_id: this.topic_id,
					grade: this.grade,
					term:this.term
				};
				this.$emit("setCurConfig", config);
			},
			close() {
				this.visible = false;
			},

			chageParentEdit() {
				// if(!this.content_permission){
				//     this.model_permission=false
				// }
			},
			curKeyChange() {
				switch (this.permission_type) {
					case "TEACHER":
					case "KINDERGARTEN":
						this.content_permission = false;
						this.model_permission = false;
						break;
					default:
						break;
				}
			},

			tagsChange(val) {
				if (val.findIndex(e => e == 0) != -1) {
					this.datasource_ids = [0];
				}
			}
		},
		mounted() { }
	};
</script>

<style scoped lang="scss">
	.in /deep/ .el-drawer__header {
		margin-bottom: 10px;
	}

	.el-main {
		padding: 0 20;
	}
	.el-row {
		margin: 0 0 10 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/book/setConfig.vue